import { mpx } from "@didi/es-mpx-creator";
import { GET_12306_TICKETS } from "../urls";

export const get12306Tickets = (data) => {
  return mpx.$http.post(GET_12306_TICKETS, { data });
};
